import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow , Chip } from '@mui/material';
import moment from 'moment';

export default function SellHolidayTable({sellListData}) {
    console.log(sellListData)
    return <>
        <h6 className='fs-5 fw-600 mb-4 mt-2'>Sell PTO Request List</h6>
        <TableContainer>
            <Table sx={{ maxWidth: "90vw", overflow: "scroll" }} aria-label="simple table">
                <TableHead sx={{ backgroundColor: "#E5E9EB" }} >
                    <TableRow>
                        <TableCell >Absent Code</TableCell>
                        <TableCell >Status</TableCell>
                        <TableCell >Date</TableCell>
                        <TableCell >Type</TableCell>
                        <TableCell >Total</TableCell>
                        <TableCell >Note</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sellListData && sellListData.map(i => (
                        <TableRow key={i.Accrual_Request_Id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                            <TableCell >{i.sub_type.SO_Desc}</TableCell>
                            <TableCell >
                                <Chip
                                    style={{ 
                                        backgroundColor:  i.Status == 'Accepted' ? '#01784F1A' : '#E627191A', 
                                        border : i.Status == 'Accepted' ? '1px solid #01784F' : '1px solid #E62719',
                                        color : i.Status == 'Accepted' ? '#01784F' : ' #E62719'
                                    }}
                                    variant="outlined" 
                                    label={i.Status}
                                />
                            </TableCell>
                            <TableCell >{moment(i.Date).format('MM/DD/YYYY')}</TableCell>
                            <TableCell >{i.Type}</TableCell>
                            <TableCell >{i.Total}</TableCell>
                            <TableCell >{i.Note}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </>
}
